import React, { createContext, useContext, useState, useCallback } from "react";
import { translations, LANGUAGES } from "./translations";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("sambiva_lang") || "EN");

  const changeLang = useCallback((l) => {
    if (LANGUAGES.includes(l)) {
      setLang(l);
      localStorage.setItem("sambiva_lang", l);
    }
  }, []);

  const t = useCallback(
    (path) => {
      const parts = path.split(".");
      let cur = translations[lang];
      let fallback = translations.EN;
      for (const p of parts) {
        cur = cur?.[p];
        fallback = fallback?.[p];
      }
      return cur ?? fallback ?? path;
    },
    [lang]
  );

  // Resolve a DB translations object { pt: {...}, es: {...} } for the active language
  const tr = useCallback(
    (obj, field, defaultVal) => {
      if (lang === "EN") return defaultVal;
      const key = lang.toLowerCase();
      return obj?.[key]?.[field] ?? defaultVal;
    },
    [lang]
  );

  return (
    <LanguageContext.Provider value={{ lang, changeLang, t, tr }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
}
